const tr = {
    coupon:{
        attributes:{
            name: 'Cupom',
            promotion_type: 'Tipo de Promoção',
            user_limit: 'Limite de Usuários',
            start_date: 'Data de Início',
            expires_at: 'Data de Expiração',
            discount_type: 'Desconto',
            discount_value: 'Valor',
            times_used: 'Vezes Usado',
            whiteSpace: ''
          },
          extras:{
            create: 'Novo Cupom',
            edit: 'Editar Cupom',
            show: 'Visualizando Cupom',
            delete: 'Excluir Cupom'
          },
          defSingular: 'Cupom',
          defPlural: 'Cupons',
        }
  };
  
  export default tr;
  